const targetMetrics = {
    CTR: 'ctr',
    VTR: 'vtr',
    VCR: 'vcr',
};

export default targetMetrics;
